(() => {
  if (!window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
  const mobileQuery = matchMedia('(max-width: 980px)');
  const panels = [];
  for (const owner of document.querySelectorAll('[data-vv-search], .mobile-menu')) {
    const content = owner.querySelector('form, nav');
    const trigger = owner.querySelector('summary');
    if (!content || !trigger) continue;
    const marker = document.createComment('panel');
    content.before(marker);
    const dialog = document.createElement('dialog');
    dialog.className = 'vr-shell-panel';
    const title = owner.matches('.mobile-menu') ? trigger.textContent.trim() : trigger.getAttribute('aria-label') || trigger.textContent.trim();
    dialog.setAttribute('aria-label', title);
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'vr-shell-panel__close';
    close.textContent = document.body.dataset.vrCloseLabel;
    const head = document.createElement('div');
    head.className = 'vr-shell-panel__head';
    const label = document.createElement('strong');
    label.textContent = title;
    head.append(label, close);
    dialog.append(head);
    document.body.append(dialog);
    panels.push(dialog);
    owner.addEventListener('toggle', () => {
      if (!owner.open || dialog.open) return;
      for (const panel of panels) if (panel !== dialog && panel.open) panel.close();
      dialog.append(content);
      dialog.showModal();
      if (owner.matches('[data-vv-search]')) content.querySelector('input[type=search]')?.focus();
      document.documentElement.classList.add('vr-panel-open');
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      marker.after(content);
      owner.open = false;
      if (!panels.some(panel => panel.open)) document.documentElement.classList.remove('vr-panel-open');
      trigger.focus({preventScroll: true});
    });
    if (owner.matches('.mobile-menu')) mobileQuery.addEventListener('change', event => {
      if (!event.matches && dialog.open) dialog.close();
    });
  }
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  window.addEventListener('pageswap', event => {
    if (!event.viewTransition) return;
    const destination = event.activation?.entry?.url;
    if (reduceMotion.matches || !destination || !new URL(destination).pathname.includes('/products/')) event.viewTransition.skipTransition();
  });
  for (const name of ['pointerdown', 'keydown']) window.addEventListener(name, () => {
    document.activeViewTransition?.skipTransition();
  }, {passive: true});
  function enhanceGallery(scope = document) {
    for (const gallery of scope.querySelectorAll('[data-vv-gallery]')) {
      if (gallery.dataset.vrSwipe) continue;
      gallery.dataset.vrSwipe = 'true';
      const stage = gallery.querySelector('.vv-gallery__stage');
      const controls = [...gallery.querySelectorAll('[data-vv-thumb]')];
      if (!stage || controls.length < 2) continue;
      let start;
      stage.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'touch') return;
        start = {x: event.clientX, y: event.clientY};
      }, {passive: true});
      stage.addEventListener('pointerup', event => {
        if (!start) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        start = null;
        if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        const current = controls.findIndex(button => button.getAttribute('aria-pressed') === 'true');
        const next = Math.max(0, Math.min(controls.length - 1, current + (dx < 0 ? 1 : -1)));
        if (next !== current) controls[next].click();
      }, {passive: true});
      stage.addEventListener('pointercancel', () => {start = null;}, {passive: true});
    }
  }
  enhanceGallery();
  document.addEventListener('shopify:section:load', event => enhanceGallery(event.target));
})();
